/**
 * Formatação global de status — converte snake_case/UPPER_CASE para labels legíveis.
 * Use `formatStatusLabel()` em qualquer exibição de status ao usuário.
 */

/** Mapa canônico (chaves normalizadas em minúsculas) */
export const STATUS_LABELS: Record<string, string> = {
  // Contrato
  pendente: 'Pendente',
  em_andamento: 'Em Andamento',
  ativo: 'Ativo',
  assinado: 'Assinado',
  assinada: 'Assinado',
  cancelado: 'Cancelado',
  contemplado: 'Contemplado',
  rascunho: 'Rascunho',
  proposta: 'Proposta',
  concluido: 'Concluído',
  finalizado: 'Finalizado',
  suspenso: 'Suspenso',
  rejeitado: 'Rejeitado',
  inativo: 'Inativo',
  aguardando_entrada: 'Aguardando Entrada',
  enviado_para_relacionador: 'Enviado para Relacionador',
  expirado: 'Expirado',

  // Agendamento
  confirmado: 'Confirmado',
  realizado: 'Realizado',
  faltou: 'Faltou',
  nova_tentativa: 'Nova Tentativa',
  reagendado: 'Reagendado',

  // Cliente / proposta
  draft: 'Rascunho',
  pending: 'Pendente',
  signed: 'Assinado',
  expired: 'Expirado',
  cancelled: 'Cancelado',

  // Pagamento / financeiro
  pago: 'Pago',
  atraso: 'Atraso',
  pendencia: 'Pendência',

  // Usuário
  active: 'Ativo',
  inactive: 'Inativo',
  rejected: 'Rejeitado',

  // Lances / assembleia
  contemplado_lance: 'Contemplado',
  nao_contemplado: 'Não Contemplado',
  aguardando: 'Aguardando',
  ofertado_portal: 'Ofertado no Portal',
  inadimplente: 'Inadimplente',
};

/** Normaliza chave: trim + lowercase */
export function normalizeStatusKey(status: string): string {
  return status.trim().toLowerCase();
}

/** Fallback: em_andamento → Em Andamento */
export function humanizeStatus(status: string): string {
  return status
    .trim()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Retorna label amigável para exibição.
 * @example formatStatusLabel('em_andamento') → 'Em Andamento'
 */
export function formatStatusLabel(status: string | null | undefined): string {
  if (status == null || String(status).trim() === '') return '—';
  const key = normalizeStatusKey(String(status));
  return STATUS_LABELS[key] ?? humanizeStatus(String(status));
}

/** Alias semântico — contrato */
export const formatContratoStatusLabel = formatStatusLabel;

/** Alias semântico — agendamento */
export const formatAgendamentoStatusLabel = formatStatusLabel;
